import React, { FC } from "react";
import { Text } from "common/components/ui";
import { ProblemRowData } from "../types";
import { useIntl } from "react-intl";
import styled from "@emotion/styled";

const StyledText = styled(Text)(
  () => `
    overflow: hidden;
    text-overflow: ellipsis;
  `
);

export const BoxLabelCell: FC<ProblemRowData> = (problem) => {
  const { formatMessage } = useIntl();
  const { affectedCdskus, affectedSellerLPNs } = problem;

  const valueLabels = {
    unknown: formatMessage({
      id: "unknown",
      defaultMessage: "N/A",
    }),
    multiple: formatMessage(
      {
        id: "multiple",
        defaultMessage: "Multiple ({amount})",
      },
      { amount: affectedCdskus?.length }
    ),
  };

  const cdskus =
    affectedCdskus && affectedCdskus.length > 0
      ? affectedCdskus.length > 1
        ? valueLabels.multiple
        : affectedCdskus[0]
      : valueLabels.unknown;

  const sellerLPNs =
    affectedSellerLPNs && affectedSellerLPNs.length > 1 ? valueLabels.multiple : affectedSellerLPNs?.[0];

  return (
    <>
      <StyledText bold>{sellerLPNs ?? cdskus}</StyledText>
      {sellerLPNs && (
        <StyledText appearance="INFO" size="caption">
          {cdskus}
        </StyledText>
      )}
    </>
  );
};
